import LazyLoadImage from '@fingo/lib/components/images/LazyLoadImage';
import FingoNavbar from '@fingo/lib/components/layout/FingoNavbar';
import LoggedOutMobileNavItems from '@fingo/lib/components/layout/navbar/LoggedOutMobileNavItems';
import LogoWithRedirectLink from '@fingo/lib/components/logo/LogoWithRedirectLink';
import useDynamicFingoLogo from '@fingo/lib/hooks/useDynamicFingoLogo';
import useGetUser from '@fingo/lib/hooks/useGetUser';
import useIsLogged from '@fingo/lib/hooks/useIsLogged';
import { lazy } from '@loadable/component';
import Stack from '@mui/material/Stack';
import React, { Suspense } from 'react';
import useIsMexicoRegistrationDisabled from '../../../hooks/useIsMexicoRegistrationDisabled';

const LoggedInMobileNavItems = lazy(() => import('./LoggedInMobileNavItems'));

const MobileNavbar = () => {
  const isLogged = useIsLogged();
  const user = useGetUser();
  const fingoLogo = useDynamicFingoLogo();
  const isMexicoRegistrationDisabled = useIsMexicoRegistrationDisabled();

  return (
    <>
      <FingoNavbar>
        <Stack
          direction="row"
          width="100%"
          height="100%"
          alignItems="center"
          justifyContent="space-between"
        >
          <LogoWithRedirectLink
            image={(
              <LazyLoadImage
                src={fingoLogo}
                alt="fingo logo"
                width={90}
                height={35}
                format="avif"
              />
            )}
            isLogged={isLogged}
            id="nav-logo"
          />
          {!isLogged && <LoggedOutMobileNavItems withRegister={!isMexicoRegistrationDisabled} />}
          {isLogged && user && (
            <Suspense fallback={<Stack width={400} />}>
              <LoggedInMobileNavItems />
            </Suspense>
          )}
        </Stack>
      </FingoNavbar>
    </>
  );
};

export default MobileNavbar;
